import { selectionSet, type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Product } from '@chancenwerk/_cms/products/entities/Product.js';
import type { ProductLKK } from '@chancenwerk/_cms/products/entities/ProductLKK.js';
import type { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import type { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import type { School } from '@chancenwerk/master-data-management/partner/entities/School.js';

const userSelectionSet = async () => {
  const { ChancenwerkUser } = await import('@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js');
  const sel = {
    ...selectionSet(() => ChancenwerkUser, 1),
    adresse: {
      strasse: 1,
      country: 1,
      careOf: 1,
      zipCity: {
        zip: 1,
        city: 1,
      },
    },
  };

  return sel;
};

const partnerSelectionSet = async () => {
  const { Partner } = await import('@chancenwerk/master-data-management/partner/entities/Partner.js');
  const sel = {
    ...selectionSet(() => Partner, 1),
    // address: Address.allFields,
  } satisfies BaseQLSelectionSet<Partner | School>;
  delete sel['zusammenArbeitStringForDetails'];
  delete sel['startDate'];
  return sel;
};

const kpfsSelectionSet = async () => {
  const { KPF } = await import('@chancenwerk/master-data-management/kpf/entities/KPF.js');
  return {
    ...selectionSet(() => KPF, 1),
    produkt: {
      ...selectionSet(() => Product, 2),
      // durchfuehrungsTage: DurchfuehrungsTag.allFields,
    },
    schoolID: 1,
    school: await partnerSelectionSet(),
  } satisfies BaseQLSelectionSet<KPF<Product | ProductLKK>>;
};

export const chancenwerkUserMatSelectionSet = async () => {
  const { ChancenwerkUser } = await import('@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js');
  const { LegalGuardian } = await import('@chancenwerk/master-data-management/users/entities/Student.js');
  const { SemanticRelationship } = await import('@chancenwerk/db/semantics/SemanticRelationship.js');
  const res = {
    ...selectionSet(() => ChancenwerkUser, 3),
    roles: {
      name: 1,
      contexts: 1,
    },
    activeRelations: { ...selectionSet(() => SemanticRelationship, 1), object: await kpfsSelectionSet() },
    inactiveRelations: { ...selectionSet(() => SemanticRelationship, 1), object: await kpfsSelectionSet() },
    kpfs: await kpfsSelectionSet(),
    createdByPerson: await userSelectionSet(),
    contactSourcePerson: await userSelectionSet(),
    personalSignOnChrstimasCardFrom: await userSelectionSet(),
    legalGuardian1: selectionSet(() => LegalGuardian, 2),
    legalGuardian2: selectionSet(() => LegalGuardian, 2),
  };

  res['schoolInformation']['abweichendeSchuleResolved'] = await partnerSelectionSet();

  delete res['vertraege']['taetigkeiten'];
  delete res['partnerRelations'];
  delete res['levumiStatus'];
  return res;
};
